import { render, staticRenderFns } from "./QuotaBuy.vue?vue&type=template&id=7c17a308&scoped=true&"
import script from "./QuotaBuy.vue?vue&type=script&lang=js&"
export * from "./QuotaBuy.vue?vue&type=script&lang=js&"
import style0 from "./QuotaBuy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./QuotaBuy.vue?vue&type=style&index=1&id=7c17a308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c17a308",
  null
  
)

component.options.__file = "QuotaBuy.vue"
export default component.exports